import InStockIcon from './stock-in-stock';
import IncomingIcon from './stock-incoming';
import OutOfStockIcon from './stock-out-of-stock';
import StockUnknownIcon from './stock-unknown';
import CheckIcon from './check';
import StarIcon from './star';
import {
  EmoticonAngry,
  EmoticonDissatisfied,
  EmoticonNeutral,
  EmoticonSmiling,
  EmoticonLaughing,
} from './emoticons';

export {
  InStockIcon,
  IncomingIcon,
  OutOfStockIcon,
  StockUnknownIcon,
  CheckIcon,
  StarIcon,
  EmoticonAngry,
  EmoticonDissatisfied,
  EmoticonNeutral,
  EmoticonSmiling,
  EmoticonLaughing,
};
